import React from "react"
import tw from "twin.macro"

import { Icon } from "../Icon/Icon"
import { withFooterBackToTop } from "./withFooterBackToTop"
import { StyledP } from "../Styled/Text"
import { useWindowSize } from "../../hooks/useWindowSize"

const Container = tw.div`flex flex-col max-w-xl w-full md:w-322 md:pr-3-2 items-start md:mt-3` // mt-1
// const Container = tw.div`flex flex-col max-w-xl w-full mt-1 md:w-4/9 items-start mt-1`
const Wrapper = tw.div`flex w-full md:mb-2 md:pl-0 flex items-center md:mt-3-2 md:mt-0 mb-2` //mt-3-2
// const Wrapper = tw.div`w-full flex w-3/4 md:w-full mb-2 md:pl-0 flex items-center mt-3-2 md:mt-0 mb-2`

const TextWrapper = tw.div`ml-3 max-w-28 md:max-w-30`
const StyledIcon = tw(Icon)`cursor-pointer`
// const PaymentIcons = tw.div`flex w-full justify-end -mx-0-2 md:-mx-1`
// const PaymentIcons = tw.div`flex w-full pb-1 md:pl-7-2 md:pb-4`
const PaymentIcons = tw.div`flex w-full pb-1 md:pl-0 md:pb-4`
// const PaymentIcon = tw(Icon)`px-0-2 md:px-1`
const PaymentIcon = tw(Icon)`mr-1-4`
const PaymentIconLast = tw(Icon)``
const Title = tw(StyledP)``
// const Title = tw(StyledP)`text-14 md:text-18`  // font chnage

const FooterBackToTop = withFooterBackToTop(({ text, onClickIcon }) => {
  const {
    windowSize: { isMobile },
  } = useWindowSize()
  return (
    <Container>
      <Wrapper>
        {!isMobile ? (
          <StyledIcon name={`backtoTop`} size={42} onClick={onClickIcon} />
        ) : (
          <StyledIcon name={`backtoTop`} size={32} onClick={onClickIcon} />
        )}
        <TextWrapper>
          {/* <StyledP>{text}</StyledP> */}

          <Title className="body_regular">{text}</Title>
        </TextWrapper>
      </Wrapper>
      <PaymentIcons>
        <PaymentIcon name={`amex`} size={70} />
        <PaymentIcon name={`applepay`} size={70} />
        <PaymentIcon name={`visa`} size={70} />
        <PaymentIcon name={`mastercard`} size={70} />
        <PaymentIcon name={`afterpay`} size={70} />
        {/* <PaymentIcon name={`shoppay`} size={70} /> */}
        <PaymentIconLast name={`googlepay`} size={70} />
      </PaymentIcons>
    </Container>
  )
})

export default FooterBackToTop
